var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertDetailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.475,
    height: 40.168,
    viewBox: "0 0 39.475 40.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161113",
    "data-name": "Group 161113",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38838",
    "data-name": "Path 38838",
    d: "M17.963,15.628a2.55,2.55,0,0,0-4.417,0L.346,38.492a2.55,2.55,0,0,0,2.209,3.826h26.4a2.55,2.55,0,0,0,2.208-3.826Z",
    transform: "translate(0 -2.15)",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38839",
    "data-name": "Path 38839",
    d: "M18.23,34.61a1.7,1.7,0,0,1-1.7-1.7V24.018a1.7,1.7,0,0,1,3.4,0v8.891a1.7,1.7,0,0,1-1.7,1.7",
    transform: "translate(-2.476 -3.343)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38840",
    "data-name": "Path 38840",
    d: "M18.246,42.753a1.672,1.672,0,0,1-1.2-.5A1.211,1.211,0,0,1,16.835,42a1.449,1.449,0,0,1-.162-.3,1.9,1.9,0,0,1-.094-.315,1.464,1.464,0,0,1-.034-.332,1.708,1.708,0,0,1,2.032-1.666,1.6,1.6,0,0,1,.323.094,1.389,1.389,0,0,1,.289.162,1.834,1.834,0,0,1,.468.468,1.928,1.928,0,0,1,.162.289,1.544,1.544,0,0,1,.094.323,1.634,1.634,0,0,1,0,.663,1.329,1.329,0,0,1-.094.315,2.015,2.015,0,0,1-.162.3,1.834,1.834,0,0,1-.468.468,1.928,1.928,0,0,1-.289.162,2.311,2.311,0,0,1-.323.094,1.464,1.464,0,0,1-.332.034",
    transform: "translate(-2.478 -5.894)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38841",
    "data-name": "Path 38841",
    d: "M41,22.74a1.474,1.474,0,0,0,0-1.488L32.733,6.931a1.488,1.488,0,0,0-2.577,0L28.989,8.954a3.556,3.556,0,0,1,.716.854l.9,1.552a.847.847,0,0,1,1.694.03v2.905l5.305,9.19h2.113A1.473,1.473,0,0,0,41,22.74",
    transform: "translate(-4.342 -0.927)",
    fill: "#ff667b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38842",
    "data-name": "Path 38842",
    d: "M32.579,12.155a.847.847,0,0,0-1.694-.03l1.694,2.935Z",
    transform: "translate(-4.626 -1.693)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38843",
    "data-name": "Path 38843",
    d: "M25.969,16.485a1.275,1.275,0,0,0-1.275,1.275V17.8l1.115,1.932,1.436,2.486V17.76a1.276,1.276,0,0,0-1.275-1.275",
    transform: "translate(-3.699 -2.469)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38844",
    "data-name": "Path 38844",
    d: "M37.662,29.279l-10.392-18a1.869,1.869,0,0,0-3.238,0L22.571,13.81a4.4,4.4,0,0,1,.246.368l1.558,2.7v-.036a1.275,1.275,0,1,1,2.551,0v4.453l6.23,10.79h2.887a1.871,1.871,0,0,0,1.62-2.806",
    transform: "translate(-3.381 -1.549)",
    fill: "#ff334d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38845",
    "data-name": "Path 38845",
    d: "M38.682,2.427l.339.588a.412.412,0,0,1,.19-.05.425.425,0,0,1,.425.425v.689L43.3,10.424h1.439a.425.425,0,0,0,.368-.638L39.58.213a.427.427,0,0,0-.738,0l-.853,1.479a2.325,2.325,0,0,1,.693.735",
    transform: "translate(-5.69 0)",
    fill: "#fcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38846",
    "data-name": "Path 38846",
    d: "M39.818,3.912a.418.418,0,0,0-.615-.376L39.818,4.6Z",
    transform: "translate(-5.872 -0.522)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38847",
    "data-name": "Path 38847",
    d: "M36.773,7.566a.425.425,0,1,0-.85,0v.682l.85,1.473Z",
    transform: "translate(-5.381 -1.07)",
    fill: "#88000e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38848",
    "data-name": "Path 38848",
    d: "M43.514,15.848a1.052,1.052,0,0,0,0-1.063L37.005,3.51a1.063,1.063,0,0,0-1.841,0l-1,1.728a2.73,2.73,0,0,1,.446.575L35.66,7.625V6.943a.425.425,0,1,1,.85,0V9.1l4.2,7.282h1.879a1.052,1.052,0,0,0,.921-.531",
    transform: "translate(-5.118 -0.446)",
    fill: "#ff99a9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDetailIcon);
export default __webpack_public_path__ + "static/media/AlertDetailIcon.4c5867c8cd802ec9e4f272f9981eed38.svg";
export { ForwardRef as ReactComponent };